import React, { Component } from "react";
import { Link } from "react-router-dom";
import { getAuth, signOut } from "firebase/auth";

class Title extends Component {
  constructor() {
    super();
    this.handleLogout = this.handleLogout.bind(this);
  }

  handleLogout(e) {
    e.preventDefault();
    const auth = getAuth();

    signOut(auth)
      .then(() => {
        this.props.setAuthStatus({ authenticated: false });
        this.props.history.push("/");
      })
      .catch((error) => {
        alert("Error in logout");
      });
  }

  render() {
    console.log(this.props.auth.email);
    return (
      <div className="row">
        <div className="col-4"></div>
        <div className="col">
          <Link to="/" className="col">
            <img src="TaskApp.png" width="300" height="100" />
          </Link>
        </div>
        <div className="col lbl text-primary mt-4">
          {this.props.auth.email ? this.props.auth.email : ""}
        </div>
        <div className="col-2">
          <button className="btn btn-primary mt-4" onClick={this.handleLogout}>
            Logout
          </button>
        </div>
      </div>
    );
  }
}

export default Title;
